import progress from '../../utils/progress';
import uniform from '../../components/uniform';
import {init as initLazyLoad} from '../../utils/lazyload';
import {init as initFlyin} from '../../flyins/flyin';
import {init as initTeaser} from '../../components/teaser';
import {init as initScrollToTop} from '../../utils/smoothscrolling';
import {init as initCompareWidget} from '../../components/compare-widget';
import {init as initCarousel} from '../../components/carousel';
import {deleteSessionStorageData, isClickOrSpaceOrEnter} from '../../utils/util';
import {init as initToggle} from '../../components/toggle';
import {init as initMobilerefinements} from '../../components/category/mobilerefinements';
import {init as initWishlist} from '../wishlist';
import {init as initVimeoVideo} from '../../utils/videovimeo';
import {init as initProductTile} from './product-tile';

export const finiteScroll = {
    // computed/created on client side
    currentPage: 1,
    defaultPageSize: SitePreferences.DEFAULT_PAGE_SIZE
};

/**
 *
 * @param {number} pageNumber - page number
 * @returns {void}
 */
const setCurrentPageNumber = pageNumber => (finiteScroll.currentPage = pageNumber);

/**
 * @returns {string} scroll position
 */
export const getScrollPosition = () =>
    sessionStorage.getItem(`pageLocationPosition_${encodeURIComponent(window.location.href)}`);

/**
 * @returns {string} stored page
 */
export const getStoredPage = () =>
    sessionStorage.getItem(`pageLocationPagingSite_${encodeURIComponent(window.location.href)}`);

/**
 * Removes stored scroll position from the session
 */
export const removeScrollPosition = () => {
    deleteSessionStorageData(/pageLocationPosition_/);
    deleteSessionStorageData(/pageLocationPagingSite_/);
};

/**
 * @returns {number} scroll offset
 */
export const getScrollOffset = () => {
    const headerWrapper = [...document.querySelectorAll('.header-wrapper')].filter(
        element => element.offsetWidth > 0 || element.offsetHeight > 0
    )[0];
    const rect = document.querySelector('.breadcrumb.content-width-default')?.getBoundingClientRect() || 0;
    return rect.top + window.scrollY - (headerWrapper?.getBoundingClientRect().height || 0);
};

/**
 * @function
 * @description Initializes events for Size tab on PLP
 */
export const initSizeTabs = () => {
    $('#main').on('click keypress', '.refinements .refinement.sizeName .region-select', e => {
        if (isClickOrSpaceOrEnter(e)) {
            const $regionSelect = $(e.currentTarget);
            const selectedRegion = $regionSelect.find('input').val();
            $('.refinement.sizeName .RegionGroup').each((index, element) => {
                const $group = $(element);
                if ($group.attr('id') === selectedRegion) {
                    $group.addClass('active');
                } else {
                    $group.removeClass('active');
                }
            });
        }
    });
};

/**
 * Updates the custom sort dropdown
 */
export const updateCustomDropdown = () => {
    const index = $('#grid-sort-header option:selected').index();
    const dropdownItems = $('.custom-dropdown__list-item');
    dropdownItems.removeClass('selected');
    dropdownItems.eq(index).addClass('selected');
};

/**
 * @returns {'unknown'|'top'|'side'} refinements type
 */
export const getRefinementsType = () => {
    let type = 'unknown';
    if (document.querySelector('.refinements-desktop') !== null) {
        type = 'top'; // refinements in top bar.
    } else if (document.querySelector('.side-filters') !== null) {
        type = 'side';
    }

    return type;
};

/**
 * @function
 * @description add style class if needed to show-more-products link
 */
export const applyShowMoreProductsStyle = () => {
    let hasRecommendations = false;
    let hasSeoDescription = false;
    const recommendations = document.querySelector('.bottomcontent .recommandations');
    const seoDescription = document.querySelector('.bottomcontent .bottom-category-description');

    if (recommendations !== null && recommendations.childElementCount.length !== 0) {
        hasRecommendations = true;
    }

    if (seoDescription !== null && seoDescription.childElementCount.length !== 0) {
        hasSeoDescription = true;
    }

    if (!hasRecommendations && !hasSeoDescription) {
        document.querySelector('.show-more-products-button')?.classList.add('no-content-below');
    }
};

/**
 * Starts the loading animation on the "load more" button
 */
export const startLoading = () => {
    const loadingPlaceHolder = document.querySelector('.show-more-products-placeholder[data-loading-state="unloaded"]');
    loadingPlaceHolder.setAttribute('data-loading-state', 'loading');
    loadingPlaceHolder.classList.add('additional-products-loading');
    const loadMoreText = loadingPlaceHolder.nextElementSibling;
    if (loadMoreText !== null) {
        loadMoreText.style.visibility = 'hidden';
    }
};

/**
 * Reinitializes the product tiles
 */
export const reInitTiles = () => {
    applyShowMoreProductsStyle();
    initProductTile();
    uniform();
    initLazyLoad();
    initWishlist();

    const event = document.createEvent('Event');
    event.initEvent('moreproductsloaded', true, false);
    document.body.dispatchEvent(event);
};

/**
 * Reinitializes the product grid sections
 *
 * @param {number} scrollOffset - scroll offset
 */
export const reInitSections = scrollOffset => {
    const offset = scrollOffset || getScrollOffset();
    const refinementsType = getRefinementsType();

    initCompareWidget();
    initProductTile();
    initFlyin();
    progress.hide();
    uniform();
    applyShowMoreProductsStyle();
    initTeaser();
    initScrollToTop();
    initCarousel();
    initLazyLoad();
    setCurrentPageNumber(getStoredPage());
    removeScrollPosition();
    initToggle();
    initSizeTabs();
    if (refinementsType !== 'side') {
        initMobilerefinements();
    }
    initWishlist();
    initVimeoVideo();
    updateCustomDropdown();

    const event = new Event('productlistingupdated', {bubbles: true, cancelable: false});
    document.body.dispatchEvent(event);

    const updateEvent = new CustomEvent('plp.updateproductlisting.done', {
        bubbles: true,
        cancelable: false,
        detail: {offset}
    });
    window.dispatchEvent(updateEvent);
};
